import type { AxiosResponse } from 'axios';

export const parseContentType = (headers: AxiosResponse['headers']): string => {
  const responseContentTypeHeader = headers['content-type'];
  if (typeof responseContentTypeHeader !== 'string') {
    return '';
  }

  const [responseContentType] = responseContentTypeHeader.split(';').map((part) => part.trim());

  return responseContentType;
};
